import { render, staticRenderFns } from "./Cep.vue?vue&type=template&id=5a54638f&scoped=true"
import script from "./Cep.vue?vue&type=script&lang=js"
export * from "./Cep.vue?vue&type=script&lang=js"
import style0 from "./Cep.vue?vue&type=style&index=0&id=5a54638f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a54638f",
  null
  
)

export default component.exports